import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import banner9 from "../assets/banner3.jpg";
import { FaPhoneVolume, FaRegEnvelope, FaWhatsapp } from "react-icons/fa6";
import { HiOutlineMapPin, HiOutlineGlobeAlt } from "react-icons/hi2";

export default function ContactUsContent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section className="py-5 bg-light">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <h2 className="display-5 fw-bold mb-4">Ready to Transform Your Business?</h2>
            <p className="fs-5 text-muted mb-5">
              Contact ATRIC Business Consulting Limited for expert guidance in Management Accounting, 
              Taxation, Internal Audit, Project Management, and Financial Management services.
            </p>

            <div className="list-unstyled">
              <div className="mb-4 p-3 border rounded hover-shadow">
                <div className="d-flex align-items-center mb-2">
                  <FaPhoneVolume className="fs-4 text-primary me-3" />
                  <strong><a href="tel:+255717918808" className="text-decoration-none text-dark">+255 (0)717 918 808</a></strong>
                </div>
                <small className="text-muted">Primary Line</small>
              </div>
              <div className="mb-4 p-3 border rounded hover-shadow">
                <div className="d-flex align-items-center mb-2">
                  <FaPhoneVolume className="fs-4 text-primary me-3" />
                  <strong><a href="tel:+255783000766" className="text-decoration-none text-dark">+255 (0)783 000 766</a></strong>
                </div>
                <small className="text-muted">Alternate Line</small>
              </div>
              <div className="mb-4 p-3 border rounded hover-shadow">
                <div className="d-flex align-items-center">
                  <FaRegEnvelope className="fs-4 text-primary me-3" />
                  <strong><a href="mailto:info@atric.co.tz" className="text-decoration-none text-dark">info@atric.co.tz</a></strong>
                </div>
              </div>
              <div className="mb-4 p-3 border rounded hover-shadow">
                <div className="d-flex align-items-center">
                  <FaWhatsapp className="fs-4 text-success me-3" />
                  <strong><a href="https://wa.me/255717918808" className="text-decoration-none text-dark" target="_blank" rel="noopener noreferrer">WhatsApp +255 717 918 808</a></strong>
                </div>
              </div>
              <div className="mb-5 p-3 border rounded hover-shadow">
                <div className="d-flex align-items-center">
                  <HiOutlineGlobeAlt className="fs-4 text-primary me-3" />
                  <strong><a href="https://www.atric.co.tz" className="text-decoration-none text-dark" target="_blank" rel="noopener noreferrer">www.atric.co.tz</a></strong>
                </div>
              </div>

              <div className="p-4 border rounded bg-white shadow-sm">
                <div className="d-flex align-items-start">
                  <HiOutlineMapPin className="fs-4 text-primary me-3 mt-1 flex-shrink-0" />
                  <div>
                    <strong className="d-block mb-2">ATRIC Business Consulting Limited</strong>
                    <div>2nd Floor, The Tax Hub Building<br/>Dar es Salaam, Tanzania</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="card border-0 shadow-lg h-100">
              <img src={banner9} className="card-img-top" alt="ATRIC office" style={{ height: '400px', objectFit: 'cover' }} />
              <div className="card-body p-4">
                <h5 className="card-title fw-bold text-primary mb-0">LET'S TALK BUSINESS</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

